import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {APP_INITIALIZER, ErrorHandler, importProvidersFrom} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {provideRouter, Router} from '@angular/router';
import { HttpRequestsInterceptor } from 'src/app/core/interceptors/http-requests.interceptor';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { provideToastr } from 'ngx-toastr';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { CDK_DRAG_CONFIG } from '@angular/cdk/drag-drop';
import * as Sentry from "@sentry/angular";
import {PermissionAccessService} from "@pages/permissions/services/permission-access.service";
import {AuthService} from "@core_services/auth.service";
import {ToasterService} from "@core_services/toaster.service";
import {initializeAuthUserPermissionsFactory} from "@pages/permissions/factories/auth-user-permissions.factory";

if (environment.production) {
  Sentry.init({
    dsn: "https://b825d19f9d400a85599dd553d409fe45@o4506263706402816.ingest.us.sentry.io/4507972968251392",
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    environment: environment.name,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/services1\.revolab\.tech\/api\/dashboard/]
  });
}

bootstrapApplication(
    AppComponent,
    {
        providers: [
            provideRouter(routes),
            provideToastr({
                preventDuplicates: true,
                countDuplicates: true
            }),
            provideAnimations(),
            importProvidersFrom(
                NgxWebstorageModule.forRoot({
                    prefix: '',
                    separator: '',
                    caseSensitive: true
                }),
                HttpClientModule,
                RecaptchaV3Module,
            ),
            { provide: HTTP_INTERCEPTORS, useClass: HttpRequestsInterceptor, multi: true },
            { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
            { provide: CDK_DRAG_CONFIG, useValue: {
                    dragStartThreshold: 0,
                    pointerDirectionChangeThreshold: 5,
                    zIndex: 10000,
                }
            },
            {
              provide: ErrorHandler,
              useValue: Sentry.createErrorHandler(),
            },
            {
              provide: Sentry.TraceService,
              deps: [Router],
            },
            {
              provide: APP_INITIALIZER,
              useFactory: () => () => {},
              deps: [Sentry.TraceService],
              multi: true,
            },
            AuthService,
            PermissionAccessService,
            ToasterService,
            {
              provide: APP_INITIALIZER,
              useFactory: initializeAuthUserPermissionsFactory,
              deps: [AuthService, PermissionAccessService, ToasterService],
              multi: true,
            },
        ]
    }
).catch(e => console.error(e));
